// extracted by mini-css-extract-plugin
export default {"preview":"wnfB5","icon":"nZ6Dx","title":"gSior"};